import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Icon = ({ icon, className, onClick }) => {
  return (
    <FontAwesomeIcon icon={icon} className={className} onClick={onClick} />
  )
}
